import React, { useCallback, useEffect, useState } from "react";
import OrgChart from "react-orgchart";
import "react-orgchart/index.css";
import "./organogram.css";
import InsideHeader from "../../../components/InsideHeader";
import { fetchOrganogram } from "../../../features/dropdown/dropdownSlice";
import { useDispatch, useSelector } from "react-redux";
import CardLoading from "../../../components/CardLoading";

const Organogram = () => {
  const dispatch = useDispatch();
  const { organogram, loading } = useSelector((state) => state.dropdown);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [collapsedIds, setCollapsedIds] = useState(new Set());

  async function fetchData(page, size) {
    dispatch(
      fetchOrganogram({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      }),
    );
  }

  useEffect(() => {
    fetchData();
  }, []);

  const toggleCollapse = useCallback((nodeId) => {
    setCollapsedIds((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) {
        next.delete(nodeId);
      } else {
        next.add(nodeId);
      }
      return next;
    });
  }, []);

  const filterTree = useCallback(
    (node) => {
      if (!node) return node;
      const nodeId = node?.ogId || node?.ogTitle;
      const isCollapsed = collapsedIds.has(nodeId);
      return {
        ...node,
        _hasChildren: node?.children?.length > 0,
        _isCollapsed: isCollapsed,
        children: isCollapsed
          ? []
          : (node?.children || []).map((child) => filterTree(child)),
      };
    },
    [collapsedIds],
  );

  const MyNodeComponent = ({ node }) => {
    const hasChildren = node?._hasChildren;
    const isCollapsed = node?._isCollapsed;
    const nodeId = node?.ogId || node?.ogTitle;

    return (
      <div
        id="initechOrgChart"
        className="initechNode"
        onClick={() => hasChildren && toggleCollapse(nodeId)}
        style={{ cursor: hasChildren ? "pointer" : "default" }}
      >
        <div className="flex flex-col gap-y-1 items-center">
          <img
            src="https://www.w3schools.com/howto/img_avatar.png"
            className="w-[50%] h-[50%] rounded-full"
            alt="avatar"
          />
          {node?.ogTitle}
          {hasChildren && (
            <span className="collapse-indicator">
              {isCollapsed ? "+" : "−"}
            </span>
          )}
        </div>
      </div>
    );
  };

  if (loading) return <CardLoading />;

  const visibleTree = organogram ? filterTree(organogram) : null;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Organization Organogram"
        subtitle="Have a view of your oragnization organogram"
        back={false}
      />
      <div className="flex overflow-x-auto h-full mt-[1.25rem]">
        {visibleTree && visibleTree?.children ? (
          <OrgChart tree={visibleTree} NodeComponent={MyNodeComponent} />
        ) : (
          <div className="flex items-center justify-center w-full py-20 text-[#9CA3AF] text-[16px]">
            No organogram data available
          </div>
        )}
      </div>
    </div>
  );
};

export default Organogram;
